var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, forwardRef } from "react";
import { LegendSegmented } from "./index";
var FieldsetSegmented = forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.noLegend, noLegend = _c === void 0 ? false : _c, children = _a.children, className = _a.className, style = _a.style, otherProps = __rest(_a, ["size", "noLegend", "children", "className", "style"]);
    var legendComponent = undefined;
    var elementsComponent = [];
    Children.forEach(children, function (child) {
        switch (child.type) {
            case LegendSegmented:
                legendComponent = child;
                break;
            default:
                elementsComponent.push(child);
                break;
        }
    });
    return (React.createElement("fieldset", __assign({}, otherProps, { ref: ref, className: "fr-segmented".concat(size ? " fr-segmented--".concat(size) : "").concat(noLegend ? " fr-segmented--no-legend" : "").concat(className ? " ".concat(className) : ""), style: style }),
        legendComponent,
        React.createElement("div", { className: "fr-segmented__elements" }, elementsComponent)));
});
export default FieldsetSegmented;
